import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent {
  @Input() title: string;
  @Input() content: string;

  constructor(public activeModal: NgbActiveModal) { }

  closeModal(val: boolean) {
    if (val) {
      this.activeModal.close(val);
    } else {
      this.activeModal.dismiss(val);
    }
  }
}
